import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { environment } from '@env/environment';
import { SimulationResponse, TimelineResponse } from '../models/survey-timeline.model';

/**
 * SEMAR survey simulation backend for the Smart Maritime Assistance page.
 * - `getTimeline` hits the MCP core API (environment.apiUrl) via ApiService.
 * - `postSimulation` / `resetHistory` hit the SEMAR API (environment.apiSemarApiURL).
 * All calls go through HttpClient, so authInterceptor attaches the Bearer token.
 */
@Injectable({ providedIn: 'root' })
export class SemarSimulationService {
  private api = inject(ApiService);
  private http = inject(HttpClient);
  private readonly semarBase = environment.apiSemarApiURL;

  /** Survey timeline (class + statutory) for a vessel. */
  getTimeline(noreg: string | number): Observable<TimelineResponse> {
    return this.api.get<TimelineResponse>(API_ENDPOINTS.semar.generateTimeline(noreg));
  }

  /** Run a survey simulation from a chat prompt. */
  postSimulation(message: string): Observable<SimulationResponse> {
    return this.http.post<SimulationResponse>(
      `${this.semarBase}${API_ENDPOINTS.semar.simulation}`,
      { message },
    );
  }

  /** Reset the simulation chat context (interface 'semar_simulation'). */
  resetHistory(): void {
    this.http
      .delete(`${this.semarBase}${API_ENDPOINTS.semar.deleteHistory}`, {
        params: { interface_type: 'semar_simulation' },
      })
      .subscribe({
        error: (err) => console.error('SEMAR: gagal reset riwayat simulasi:', err),
      });
  }
}
